<script setup lang="ts">
import { useNotifications } from '~/composables/useStates/useNotifications';
const viewport = useViewport();
const {
  notificationsState,
  panelOpen,
  status,
  fetchNotifications,
  resetNotificationState,
} = useNotifications();
const mdOrLess = computed(() => viewport.isLessThan('tablet'));
watch(panelOpen, (newVal) => {
  if (
    !newVal &&
    (notificationsState.value.page > 1 ||
      notificationsState.value.hasDateFilter)
  )
    resetNotificationState(true);
});
onBeforeMount(() => {
  if (status.value === 'NOT_FETCHED')
    fetchNotifications({ overwriteStorage: true });
  useWebSockets().initWebSocket();
});
</script>
<template>
  <DesignSystemDrawer
    v-model:visible="panelOpen"
    :position="mdOrLess ? 'bottom' : 'right'"
    :over-ride-content-class="true"
    :custom-container-class="
      mdOrLess
        ? 'bg-base-secondary h-full w-full bottom-0 left-0'
        : 'bg-base-secondary h-full w-full md:w-[360px] top-0 right-0'
    "
  >
    <MarketingNotifications @close="panelOpen = false" />
  </DesignSystemDrawer>
</template>
